const highlightHint = function(el){
  el.classList.add('-highlight-update')

  setTimeout(()=>{
    el.classList.remove('-highlight-update')
  }, 700)
}

export {highlightHint}